/* eslint-disable ember/no-controller-access-in-routes, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { next } from '@ember/runloop';
import { service } from '@ember/service';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import TransactionType from '@linc-technologies/linced-common/enums/transaction-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class ReconciliationRoute extends Route {
  queryParams = {
    from: {
      refreshModel: true,
    },
    to: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    return hash({
      ledgers: this.store.findAll('finance/ledger'),
      payments: this.store.query('finance/transaction', {
        type: TransactionType.PAYMENT,
        dateFrom: params.from,
        dateTo: params.to,
        include: 'lineItems,ledgerItems,accounts',
        isNotCancelled: true,
      }),
      apportionments: this.store.query('finance/transaction', {
        type: TransactionType.APPORTIONMENT,
        dateFrom: params.from,
        dateTo: params.to,
        include: 'lineItems,ledgerItems,accounts',
        isNotCancelled: true,
      }),
      refunds: this.store.query('finance/transaction', {
        type: TransactionType.REFUND,
        dateFrom: params.from,
        dateTo: params.to,
        include: 'lineItems,ledgerItems,accounts',
        isNotCancelled: true,
      }),
      caregivers: this.store.query('person', { type: PersonType.CAREGIVER }),
    });
  }

  activate() {
    super.activate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', true);
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', false);
    });
  }

  resetController(controller) {
    controller.reset();
  }
}
